<header class="chat__header">
  <div class="chat__identity">
    <div class="chat__avatar" aria-hidden="true">
      <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
    </div>
    <div class="chat__titles">
      <h2 class="chat__title">{{ 'ChatBot-Title' | translate: {Default: 'HR Assistant'} }}</h2>
      <span class="chat__status" [ngClass]="'chat__status--' + session.connectionState()">
        <span class="chat__status-dot"></span>
        <ng-container [ngSwitch]="session.connectionState()">
          <ng-container *ngSwitchCase="'connected'">{{ 'ChatBot-Online' | translate: {Default: 'Online'} }}</ng-container>
          <ng-container *ngSwitchCase="'error'">{{ 'ChatBot-Offline' | translate: {Default: 'Offline'} }}</ng-container>
          <ng-container *ngSwitchDefault>{{ 'ChatBot-Connecting' | translate: {Default: 'Connecting…'} }}</ng-container>
        </ng-container>
      </span>
    </div>
  </div>

  <div class="chat__header-actions">
    <button type="button" class="icon-btn" (click)="newChat()" [disabled]="session.isEmpty()"
            [matTooltip]="'ChatBot-NewChat' | translate: {Default: 'New chat'}"
            [attr.aria-label]="'ChatBot-NewChat' | translate: {Default: 'New chat'}">
      <mat-icon class="material-icons-outlined">edit_note</mat-icon>
    </button>
    <ng-container *ngIf="variant === 'panel'">
      <button type="button" class="icon-btn" (click)="openFullPage()"
              [matTooltip]="'ChatBot-OpenFullPage' | translate: {Default: 'Open full page'}"
              [attr.aria-label]="'ChatBot-OpenFullPage' | translate: {Default: 'Open full page'}">
        <mat-icon class="material-icons-outlined">open_in_full</mat-icon>
      </button>
      <button type="button" class="icon-btn" (click)="closed.emit()"
              [matTooltip]="'ChatBot-Close' | translate: {Default: 'Close'}"
              [attr.aria-label]="'ChatBot-Close' | translate: {Default: 'Close'}">
        <mat-icon class="material-icons-outlined">close</mat-icon>
      </button>
    </ng-container>
  </div>
</header>

<div class="chat__feed-wrap">
  <div #feed class="chat__feed" (scroll)="onScroll()" role="log" aria-live="polite">

    <!-- Empty state -->
    <section *ngIf="session.isEmpty(); else conversation" class="welcome">
      <div class="welcome__badge" aria-hidden="true">
        <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
      </div>
      <h3 class="welcome__title">
        <ng-container *ngIf="firstName; else noName">
          {{ 'ChatBot-GreetingName' | translate: {Default: 'Hi ' + firstName + ', how can I help?', name: firstName} }}
        </ng-container>
        <ng-template #noName>{{ 'ChatBot-Greeting' | translate: {Default: 'Hi, how can I help?'} }}</ng-template>
      </h3>
      <p class="welcome__subtitle">
        {{ 'ChatBot-Intro' | translate: {Default: 'Ask about your time off, HR policies, or get everyday tasks done.'} }}
      </p>

      <div class="suggestions">
        <button type="button" *ngFor="let s of suggestions" class="suggestion" (click)="sendSuggestion(s)">
          <mat-icon class="material-icons-outlined suggestion__icon">{{ s.icon }}</mat-icon>
          <span class="suggestion__text">{{ s.key | translate: {Default: s.text} }}</span>
          <mat-icon class="material-icons-outlined suggestion__arrow">arrow_forward</mat-icon>
        </button>
      </div>
    </section>

    <ng-template #conversation>
      <div class="chat__messages">
        <app-chat-message *ngFor="let m of session.messages(); trackBy: trackMessage" [message]="m"></app-chat-message>
      </div>
    </ng-template>
  </div>

  <button *ngIf="showJumpToLatest" type="button" class="jump" (click)="scrollToBottom(true)">
    <mat-icon class="material-icons-outlined">arrow_downward</mat-icon>
    {{ 'ChatBot-JumpToLatest' | translate: {Default: 'Jump to latest'} }}
  </button>
</div>

<footer class="chat__footer">
  <div *ngIf="session.connectionState() === 'error'" class="banner" role="alert">
    <mat-icon class="material-icons-outlined">cloud_off</mat-icon>
    <span>{{ 'ChatBot-ConnectionError' | translate: {Default: "Can't reach the assistant right now."} }}</span>
    <button type="button" class="banner__retry" (click)="retryConnection()">
      {{ 'ChatBot-Retry' | translate: {Default: 'Retry'} }}
    </button>
  </div>

  <form class="composer" (ngSubmit)="send()" [class.composer--disabled]="session.connectionState() === 'error'">
    <textarea #input
              class="composer__input"
              name="draft"
              [(ngModel)]="draft"
              (keydown)="onKeydown($event)"
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="6"
              [placeholder]="'ChatBot-Placeholder' | translate: {Default: 'Ask me anything about HR…'}"
              [attr.aria-label]="'ChatBot-Placeholder' | translate: {Default: 'Ask me anything about HR…'}"></textarea>

    <button *ngIf="!session.sending(); else stopBtn" type="submit" class="composer__send" [disabled]="!draft.trim()"
            [attr.aria-label]="'ChatBot-Send' | translate: {Default: 'Send'}">
      <mat-icon class="material-icons-outlined">arrow_upward</mat-icon>
    </button>
    <ng-template #stopBtn>
      <button type="button" class="composer__send composer__send--stop" (click)="session.stop()"
              [matTooltip]="'ChatBot-Stop' | translate: {Default: 'Stop generating'}"
              [attr.aria-label]="'ChatBot-Stop' | translate: {Default: 'Stop generating'}">
        <mat-icon class="material-icons-outlined">stop</mat-icon>
      </button>
    </ng-template>
  </form>

  <p class="chat__disclaimer">
    {{ 'ChatBot-Disclaimer' | translate: {Default: 'The assistant can make mistakes. Check important information.'} }}
  </p>
</footer>
